/**
 * Multi-Brand Domain Constants
 * Centralized constants for Tax.Network and Tributário brands
 * 
 * BRANDING RULES:
 * - Location (ID 33): locale=pt + locationId=33 → tributario.com.br/
 * - Publication/Topic: locale=pt + locationId=33 → tributario.com.br/{slug}
 * - Expert/Profile: locale=pt + country=BR → tributario.com.br/{vanityUrl}
 * - Route/Page: locale=pt (any PT content) → tributario.com.br/{route-slug}
 */

/** Brazil location ID in locations table */
export const BRAZIL_LOCATION_ID = '33';

/** Brazil country code for user profiles */
export const BRAZIL_COUNTRY_CODE = 'BR';

/** Tributário domain (Brazil brand) */
export const TRIBUTARIO_DOMAIN = 'tributario.com.br';

/** Tax.Network domain (global brand) */
export const TAX_NETWORK_DOMAIN = 'tax.network';

/** Full base URLs for SEO */
export const TAX_NETWORK_BASE_URL = `https://${TAX_NETWORK_DOMAIN}`;
export const TRIBUTARIO_BASE_URL = `https://${TRIBUTARIO_DOMAIN}`;

/** Domains where cross-domain redirects should NOT occur */
const DEV_DOMAINS = ['localhost', '.lovable.app', '.lovable.dev', '.lovableproject.com'];

/** Check if locale is Portuguese (any variant) */
export function isPTLocale(locale: string): boolean {
  return locale === 'pt' || locale.startsWith('pt-');
}

/** Check if current hostname is a dev/preview domain */
export function isDevDomain(): boolean {
  const hostname = window.location.hostname;
  return DEV_DOMAINS.some(dev => hostname.includes(dev) || hostname === 'localhost');
}

/** Check if already on tributario.com.br */
export function isOnTributarioDomain(): boolean {
  const hostname = window.location.hostname;
  return hostname === TRIBUTARIO_DOMAIN || hostname.endsWith(`.${TRIBUTARIO_DOMAIN}`);
}

/** Check if on tax.network (production) */
export function isOnTaxNetworkDomain(): boolean {
  const hostname = window.location.hostname;
  return hostname === TAX_NETWORK_DOMAIN || hostname === `www.${TAX_NETWORK_DOMAIN}`;
}
